import iconShare from "core/modals/icon-share-modal";
import auth from "components/auth/auth-modal";

export const ICON_SHARE = iconShare;
export const AUTH = auth;

export const modalTypes = {
    ICON_SHARE: "ICON_SHARE",
    AUTH: "AUTH"
};
